module.exports = __webpack_public_path__ + "static/media/space-key.324655c6.svg";